import _isString from 'lodash/isString';
import { showLoader, hideLoader } from 'store/actions/commons';
import { getEventTypes, getPlans, getGuestRange } from 'services/api/catalog';
import { transformForSelect } from 'util/transformHelpers';
import { FLAT } from 'constants/transformers';
import { getThanksMessageTypes, getImageGallery } from 'services/giftTable';
import { getRecommendationTypes } from 'services/recommendations';
import { FETCH_CATALOG_SUCCEEDED, FETCH_CATALOG_FAILED } from './types';

export const fetchCatalog = (payload) => (dispatch, state) => {
  const {
    request,
    alwaysFetch = true,
    identifier,
    transformer,
    withLoader,
  } = payload;
  const { catalogs } = state;

  if (!alwaysFetch && catalogs[identifier]) return;

  if (withLoader) dispatch(showLoader());

  request()
    .then((catalogResponse) => {
      const catalog = transformer
        ? transformer(catalogResponse)
        : catalogResponse;

      dispatch({
        type: FETCH_CATALOG_SUCCEEDED,
        payload: { ...payload, catalog },
      });
    })
    .catch(() => {
      dispatch({ type: FETCH_CATALOG_FAILED, payload });
    })
    .finally(() => {
      if (withLoader) dispatch(hideLoader());
    });
};

export const fetchEventTypes = (
  withLoader = true,
  completed = false,
  transformer
) => {
  /*const eventTypesTransformer = (eventTypesCatalog) => {
    const [celebrations] = eventTypesCatalog;
    console.log('eventTypesCatalog',eventTypesCatalog);
    const celebrationsWithoutLabels = celebrations.events.map((event) => ({
      ...event,
      labels: [],
      eventTypeName: celebrations.name,
      eventTypeLabels: event.labels,
    }));
    console.log('celebrationsWithoutLabels',celebrationsWithoutLabels);
    return transformForSelect(celebrationsWithoutLabels, 'id', 'name');
  };*/

  const eventTypesTransformer = (eventTypesCatalog) => {
    const allEventsData = [];

    for (const celebrations of eventTypesCatalog) {
      for (const event of celebrations.events) {
        const eventData = {
          ...event,
          labels: [],
          eventTypeName: celebrations.name,
          eventTypeLabels: event.labels,
        };
        allEventsData.push(eventData);
      }
    }

    return transformForSelect(allEventsData, 'id', 'name');
  };

  const flatTransformer = (eventTypesCatalog) => {
    const transformed = eventTypesCatalog.map(({ events }) => events).flat();
    return transformed;
  };

  const TRANSFORMERS = {
    [FLAT]: flatTransformer,
  };

  const IDENTIFIER_BY_TRANSFORMER = {
    [FLAT]: 'flatEventTypes',
  };

  const getTransformer = () => {
    if (_isString(transformer)) {
      return TRANSFORMERS[transformer];
    }
    return !completed ? eventTypesTransformer : transformer;
  };

  const getIdentifier = () => {
    if (_isString(transformer)) {
      return IDENTIFIER_BY_TRANSFORMER[transformer] || 'eventTypes';
    }
    return completed ? 'fullEventTypes' : 'eventTypes';
  };

  const payload = {
    identifier: getIdentifier(),
    request: getEventTypes,
    catalog: [],
    alwaysFetch: false,
    transformer: getTransformer(),
    withLoader,
  };

  return fetchCatalog(payload);
};

export const fetchPlans = (withLoader = true) => {
  const payload = {
    identifier: 'plans',
    request: getPlans,
    catalog: [],
    alwaysFetch: false,
    withLoader,
  };

  return fetchCatalog(payload);
};

export const fetchGuestRange = (withLoader = true) => {
  const payload = {
    identifier: 'guestRange',
    request: getGuestRange,
    catalog: [],
    alwaysFetch: false,
    withLoader,
  };

  return fetchCatalog(payload);
};

export const fetchGiftTableMessageTypes = (withLoader = true) => {
  const payload = {
    identifier: 'thanksMessagesTypes',
    request: getThanksMessageTypes,
    catalog: [],
    alwaysFetch: false,
    withLoader,
  };

  return fetchCatalog(payload);
};

export const fetchListOfImageGallery = (withLoader = true, eventId) => {

  const payload = {
    identifier: 'listOfImageGallery',
    request: () => getImageGallery(eventId),
    catalog: [],
    withLoader,
  };

  return fetchCatalog(payload);
};

export const fetchRecommendationTypes = (withLoader = true) => {
  const payload = {
    identifier: 'recommendationTypes',
    request: getRecommendationTypes,
    catalog: [],
    withLoader,
  };

  return fetchCatalog(payload);
};
